import { useTheme } from '@mui/material/styles';
import { Box, Container, useMediaQuery } from '@mui/material';

function SimAContainer({ children, disableGutters = false, mt, sx, ...other }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('lg'));
  // display: { xs: 'none', md: 'block' },
  // disableGutters lg xl
  return (
    <Container
      disableGutters={disableGutters}
      maxWidth={'lg'}
      sx={{
        mt,
        position: 'relative',
        boxShadow: theme.customShadows.card,
        p: { xs: 2.25, sm: 2.25, md: 4, lg: 10 },
        backgroundColor: theme.palette.common.white,
        // backgroundColor: theme.palette.background.default,
        ...sx
      }}
      { ...other }
    >
      { children }
    </Container>
  )
};

export default SimAContainer;
